module.exports = __webpack_public_path__ + "static/media/btn-bellreport.beec9725.svg";